import {MarkdownQuote} from '@github/quote-selection'

import {CLASS_NAMES, IDS, withClassSelector, withIDSelector} from '../constants/dom-elements'

export function getQuotedText(text: string): string {
  if (!text) return text

  const lines = text.split('\n')

  let quotes = ''
  for (const line of lines) {
    quotes = quotes.concat(`> ${line}\n`)
  }

  return quotes
}

export type SelectionContext = {
  anchorNode: Node | null
  range: Range
}

export function selectQuoteFromComment(
  comment: HTMLDivElement | null | undefined,
  selection: SelectionContext | null,
): string | undefined {
  if (!comment) return undefined

  const quoteSelectionContainer = document.querySelector(withClassSelector(CLASS_NAMES.commentsContainer))!

  const commentBody = comment.querySelector<HTMLElement>(withClassSelector(CLASS_NAMES.markdownBody))!

  const quote = new MarkdownQuote('', undefined)

  if (
    selection &&
    commentBody.contains(selection.anchorNode) &&
    commentBody.contains(selection.range.startContainer) &&
    commentBody.contains(selection.range.endContainer) &&
    !selection.range.collapsed &&
    selection.range.toString().trim() !== ''
  ) {
    // If the selection is within the comment body, use it
    quote.range = selection.range
  } else {
    // Otherwise, use the entire comment body
    quote.select(commentBody)
  }

  if (quoteSelectionContainer) {
    const commentComposer = quoteSelectionContainer.querySelector<HTMLElement>(withIDSelector(IDS.issueCommentComposer))
    const commentComposerTextArea = commentComposer?.querySelector<HTMLTextAreaElement>('textarea')
    if (commentComposerTextArea) {
      quote.insert(commentComposerTextArea)
      return commentComposerTextArea.value
    }
  }

  return undefined
}
